import { useEffect, useRef } from 'preact/hooks';
import { cn } from '../../lib/utils';

function Input({ className, type = 'text', autoFocus, ...props }) {
  const ref = useRef(null);

  // Chromium honors the `autofocus` HTML attribute for only the first
  // element that requests it per document. Shared primitives like this
  // get mounted and unmounted repeatedly (every dropdown open, every
  // modal reopen), so the second+ mount silently fails to focus. Which
  // in turn leaves the smooth-caret overlay with no focus event to
  // latch onto. Imperatively focusing on mount bypasses the one-shot
  // limitation and makes `autoFocus` behave like users expect.
  useEffect(() => {
    if (autoFocus && ref.current) ref.current.focus();
  }, []);

  return (
    <input
      ref={ref}
      type={type}
      autoFocus={autoFocus}
      className={cn(
        'flex h-10 w-full rounded-xl border border-input bg-input/40 px-3.5 text-sm text-foreground shadow-sm outline-none transition-colors placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
}

export { Input };
